import React from 'react';

export const AvatarPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { 
    src, 
    alt, 
    size, 
    shape, 
    showBorder, 
    borderColor, 
    borderWidth,
    showShadow 
  } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px',
    display: 'inline-block'
  };
  
  const sizeMap = {
    small: '32px',
    medium: '48px',
    large: '64px',
    xlarge: '96px'
  };
  
  const dimension = sizeMap[size || 'medium'];
  
  // Determine border radius based on shape
  const getBorderRadius = () => {
    if (shape === 'circle') return '50%';
    if (shape === 'rounded') return '12px';
    return '0px'; // square
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <img
        src={src || 'https://via.placeholder.com/100'}
        alt={alt || 'Avatar'}
        style={{
          width: dimension,
          height: dimension,
          borderRadius: getBorderRadius(),
          objectFit: 'cover',
          border: showBorder !== false 
            ? `${borderWidth || 2}px solid ${borderColor || '#E5E7EB'}` 
            : 'none',
          boxShadow: showShadow 
            ? '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' 
            : 'none',
          display: 'block'
        }}
      />
    </div>
  );
};
